exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pt20[data-v-0cf8f1a7]{padding-top:20px}.spec-table[data-v-0cf8f1a7]{width:100%;font-size:12px}.spec-table td[data-v-0cf8f1a7]{padding:3px}.list p[data-v-0cf8f1a7]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0}.list[data-v-0cf8f1a7]:nth-child(2n){background:#f7f7f7}\n", ""]);

// exports
